/* DSL Storage quota warning — prune oudste localStorage keys bij near-full */
(function(){
  function bytes(){
    var b = 0;
    try {
      for (var k in localStorage) {
        if (localStorage.hasOwnProperty(k)) b += (localStorage[k].length + k.length) * 2;
      }
    } catch(e){}
    return b;
  }
  function check(){
    var b = bytes();
    if (b > 4 * 1024 * 1024) { // > 4 MB approx (most browsers cap at 5 MB)
      // Prune oldest log entries first
      try {
        var log = JSON.parse(localStorage.getItem("dsl_ab_event_log") || "[]");
        if (log.length > 50) {
          localStorage.setItem("dsl_ab_event_log", JSON.stringify(log.slice(-50)));
        }
        if (log.length === 0) {
          if (window.DSL_BANNER) window.DSL_BANNER.show({text: "LocalStorage bijna vol — sommige cached data wordt verwijderd.", variant: "error"});
        }
      } catch(e){}
    }
  }
  setTimeout(check, 5000);
  setInterval(check, 60000);
})();